import { Position } from '@xyflow/react';
import { ERFElement } from '../../../enums';
import { L_FLOW_HEX, M_FLOW_HEX } from '../../../constants';
export const SEPARATOR_3PH_CONFIG = {
    type: ERFElement.Separator3ph,
    icon: 'Separator_3ph_2d',
    templates: [
        {
            code: 'default',
            ports: [
                {
                    id: 'target_material_flow',
                    type: 'target',
                    name: 'Входной поток',
                    position: Position.Top,
                    style: { top: 7, left: 50, background: M_FLOW_HEX },
                    connectionCount: 1
                },
                {
                    id: 'source_material_gas_flow',
                    type: 'source',
                    name: 'Выходной поток газа',
                    position: Position.Top,
                    style: { top: 7, left: 89, background: M_FLOW_HEX },
                    connectionCount: 1
                },
                {
                    id: 'source_material_light_liquid_flow',
                    type: 'source',
                    name: 'Выходной поток лёгкой жидкости',
                    position: Position.Right,
                    style: { top: 29, right: 7, background: M_FLOW_HEX },
                    connectionCount: 1
                },
                {
                    id: 'source_material_heavy_liquid_flow',
                    type: 'source',
                    name: 'Выходной поток тяжелой жидкости',
                    position: Position.Bottom,
                    style: { bottom: 7, left: 89, background: M_FLOW_HEX },
                    connectionCount: 1
                },
                /* PORTS FOR LOGICAL ELEMENTS */
                {
                    id: 'target_logical_flow',
                    type: 'target',
                    name: 'Входные параметры',
                    position: Position.Left,
                    style: { top: 52, left: 19, background: L_FLOW_HEX },
                    connectionCount: Number.MAX_SAFE_INTEGER
                },
                {
                    id: 'source_logical_flow',
                    type: 'source',
                    name: 'Выходные параметры',
                    position: Position.Right,
                    style: { top: 52, right: 18, background: L_FLOW_HEX },
                    connectionCount: Number.MAX_SAFE_INTEGER
                }
            ]
        }
    ]
};
//# sourceMappingURL=RFSeparator3phNode.config.js.map